import React from 'react'
import WorksListItem from '../WorksListItem'
import { Wrapper, WorksTitle, ButtonsWrapper, FilterButton, NDAWrapper, StyledDivider, StyledEmailMe } from './style'

const WorksListSection = ({ 
  works, 
  category, 
  setCategory 
}) => 
  <Wrapper>
    <header>
      <WorksTitle>Codes // Contests</WorksTitle>
      <ButtonsWrapper>
        <FilterButton active={category === 'softwares'} onClick={() => setCategory('softwares')}>softwares</FilterButton>
        <FilterButton active={category === 'robotics'} onClick={() => setCategory('robotics')}>robotics</FilterButton>
        {category && <FilterButton onClick={() => setCategory(null)}>all</FilterButton>}
      </ButtonsWrapper>
    </header>
    <main>
      {works.map(({ work }, i) => <WorksListItem key={i} work={work} />)}
    </main>
    <NDAWrapper>
      <StyledDivider height={6} width={43} />
      <h2>How about we discuss some more work over a warm cup of coffee?</h2>
      <StyledEmailMe text='Shoot me a quick mail ↗' />
    </NDAWrapper>
  </Wrapper>

export default WorksListSection
